// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2ce6e2b0","239":"061fe09a","455":"715ace60","488":"8497e091"}[chunkId] + ".chunk.js";
};